import { createFileRoute } from "@tanstack/react-router";
import { ModuleDashboard } from "@/features/dashboards/ModuleDashboard";

// Warehousing dashboard (PX-WHS-010): features/dashboards.
export const Route = createFileRoute("/_app/warehousing/dashboard")({
  component: () => <ModuleDashboard module="warehousing" />,
});
